const finishActionTypes = {
  SET_FATAL_MESSAGES: 'SET_FATAL_MESSAGES',

  STATUS_REQUEST: 'STATUS_REQUEST',
  STATUS_FULFILLED: 'STATUS_FULFILLED',
  STATUS_FAILED: 'STATUS_FAILED',
}

export default finishActionTypes
